// extracted by css-extract-rspack-plugin
export default {"slide":"slide-3OMdk","title":"title-LIX91","page":"page-1n7Q9"};